
import { Component, Mixins } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { OrderModule } from "@/store/modules/index";
import { receiveOrderModal } from "@/lib/modals";
import NoteFields from "@/components/widgets/NoteFields.vue";
import mixin from "./mixin";

const orderModule = getModule(OrderModule);

@Component({
  name: receiveOrderModal,
  components: {
    NoteFields
  }
})
export default class ReceiveOrderModal extends Mixins(mixin) {
  note: any = { text: null, visibleOption: "0", customerViewable: true, facilityViewable: true };
  dateReceived: Date | string = null;
  loading: boolean = true;
  orders: Array<any> = [];

  get deliveryForId() {
    if(!this.selectedItem)
      return 0;
      
    return this.selectedItem.deliveryForId ?? 0;
  }

  async load() {
    this.show();

    const request = {
      orderNumbers: this.selectedItems.map(x => x.number)
    };

    try {
      this.orders = await orderModule.previewReceiveOrder(request);
    } finally {
      this.loading = false;
    }
  }

  async saveModal() {
    this.isLoading = true;
    for (let index = 0; index < this.orders.length; index++) {
      const selectedOrder = this.orders[index];
      let receivedOrder = {
        orderHeaderNumber: selectedOrder.orderHeaderNumber,
        orderNote: this.note,
        dateReceived: this.dateReceived
      };

      try {
        await orderModule.receiveOrder(receivedOrder);
        this.addActionResult({
          number: receivedOrder.orderHeaderNumber,
          success: true,
          message: `Order ${receivedOrder.orderHeaderNumber} successfully received.`
        });
      } catch (error) {
        this.addActionResult({
          number: receivedOrder.orderHeaderNumber,
          success: false,
          message: error.response.data.message,
          errors:
            error.response.data && error.response.data.errors ? error.response.data.errors : null,
          errorMessages:
            error.response.data && error.response.data.errorMessages
              ? error.response.data.errorMessages
              : null
        });
      }
    }
    await this.refreshOrders().then(() => {
      this.hideModal();
    });
  }

  noteUpdated(newNote) {
    this.note = newNote;
  }

  reset() {
    this.note = { text: null, visibleOption: "0", customerViewable: true, facilityViewable: true };
    this.dateReceived = null;
  }
}
